import { useEffect } from "react";
import { initMetaPixel } from "../../utils/metaPixel";
import { captureAttribution, updateAttribution, getFbpCookie, getFbcCookie } from "../../utils/attribution";

/**
 * MetaPixel component
 * Initializes Meta Pixel and captures attribution data
 * Should be mounted once in the app root
 */
const MetaPixel = () => {
  useEffect(() => {
    // Only initialize in production
    if (process.env.NODE_ENV !== "production") {
      console.log("Meta Pixel: Skipping initialization in non-production environment");
      return;
    }

    // Get pixel ID from environment variable
    const pixelId = "1348850783426391";

    if (!pixelId) {
      console.warn("Meta Pixel: VITE_META_PIXEL_ID not configured");
      return;
    }

    try {
      // Initialize Meta Pixel
      initMetaPixel(pixelId, {
        autoConfig: true,
        debug: false,
      });

      console.log("Meta Pixel initialized:", pixelId);

      // Capture attribution data on first load
      captureAttribution();

      // Update attribution with fbp/fbc after pixel loads
      // Wait a bit for the pixel to set cookies
      setTimeout(() => {
        const fbp = getFbpCookie();
        const fbc = getFbcCookie();

        if (fbp || fbc) {
          updateAttribution({
            fbp: fbp || undefined,
            fbc: fbc || undefined,
          });
        }
      }, 1000);
    } catch (error) {
      console.error("Error initializing Meta Pixel:", error);
    }
  }, []);

  // This component doesn't render anything
  return null;
};

export default MetaPixel;
